module.exports = __webpack_public_path__ + "img/img_internet_start.63682773.png";